import { useNavigate } from "react-router-dom";

export default function MoreWithNGC() {
  const navigate = useNavigate();

  return (
    <section
      className="rounded-2xl border border-black/5 dark:border-white/10
                 bg-white dark:bg-slate-900 shadow-sm p-5"
    >
      <h2 className="text-base font-semibold text-slate-900 dark:text-white">
        Allez plus loin avec NGC
      </h2>
      <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
        Des fonctionnalités pour gagner du temps et mieux planifier
      </p>

      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
        <button
          type="button"
          className="rounded-2xl bg-slate-900 text-white py-3 px-4 font-medium hover:opacity-95 transition
                     dark:bg-white dark:text-slate-900"
          onClick={() => navigate("/send-request")}
        >
          Envoyer / Demander à un contact
        </button>

        <button
          type="button"
          className="rounded-2xl border border-black/10 dark:border-white/10
                     bg-slate-50 dark:bg-white/5
                     py-3 px-4 font-medium text-slate-900 dark:text-white
                     hover:bg-black/5 dark:hover:bg-white/10 transition"
          onClick={() => navigate("/schedule-transfer")}
        >
          Planifier un transfert
        </button>
      </div>
    </section>
  );
}
